/* ============================================================
   article.js — article page interactions.
     - Auto-generated TOC from h2/h3 in article body
     - Active-section highlighting on scroll
     - "Copy link" share button
   ============================================================ */
(function () {
  'use strict';

  function slugify(text) {
    return text.toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 80);
  }

  function initToc() {
    var article = document.querySelector('[data-article-body]');
    var tocNav = document.querySelector('[data-toc]');
    var tocList = document.querySelector('[data-toc-list]');
    if (!article || !tocNav || !tocList) return;

    var headings = article.querySelectorAll('h2, h3');
    if (headings.length < 2) {
      tocNav.setAttribute('hidden', '');
      return;
    }

    var seen = {};
    var items = [];
    headings.forEach(function (h) {
      if (!h.id) {
        var base = slugify(h.textContent);
        var id = base;
        var n = 2;
        while (seen[id]) { id = base + '-' + n; n++; }
        seen[id] = true;
        h.id = id;
      }
      items.push(h);
    });

    items.forEach(function (h) {
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      a.className = 'toc-card__item toc-card__item--' + h.tagName.toLowerCase();
      a.setAttribute('data-toc-link', h.id);
      tocList.appendChild(a);
    });

    /* Reveal once populated */
    tocNav.removeAttribute('hidden');

    /* Active highlight */
    var links = {};
    tocList.querySelectorAll('[data-toc-link]').forEach(function (a) {
      links[a.getAttribute('data-toc-link')] = a;
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var link = links[e.target.id];
        if (!link) return;
        if (e.isIntersecting) {
          Object.keys(links).forEach(function (id) { links[id].classList.remove('is-active'); });
          link.classList.add('is-active');
        }
      });
    }, { rootMargin: '-30% 0px -55% 0px', threshold: 0 });
    items.forEach(function (h) { observer.observe(h); });
  }

  function initShare() {
    var btn = document.querySelector('[data-share-copy]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (!navigator.clipboard) return;
      navigator.clipboard.writeText(window.location.href).then(function () {
        var sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.textContent = 'Link copied to clipboard';
        document.body.appendChild(sr);
        btn.setAttribute('aria-label', 'Link copied ✓');
        setTimeout(function () {
          btn.setAttribute('aria-label', 'Copy link');
          sr.remove();
        }, 2000);
      });
    });
  }

  function init() {
    initToc();
    initShare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
